import React, { useState } from "react";
import { Form, Input } from "semantic-ui-react";
import styled from "styled-components";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { ErrorMessage } from "./AuthFormStyles";
const InputWrapper = styled.div `
  position: relative;
  width: 100%;

  .ui.input > input {
    padding-right: 45px !important;
    font-size: 16px; /* 16px to prevent iOS zooming in on input focus*/
  }
`;
const VisibilityIconWrapper = styled.div `
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.6);
  transition: color 0.2s;
  pointer-events: auto;
  z-index: 10;

  &:hover {
    color: rgba(0, 0, 0, 0.87);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
const ValidatedInput = ({ type, id, value, onChange, placeholder, errorMessage, touched, autoFocus = false, fluid = true, disabled = false, }) => {
    const [showPassword, setShowPassword] = useState(false);
    const isPasswordField = type === "password";
    const inputType = isPasswordField && showPassword ? "text" : type;
    return (React.createElement(Form.Field, { error: touched && errorMessage !== "" },
        React.createElement(InputWrapper, null,
            React.createElement(Input, { type: inputType, id: id, value: value, onChange: (e, data) => onChange(data.value), placeholder: placeholder, autoFocus: autoFocus, fluid: fluid, disabled: disabled }),
            isPasswordField && (React.createElement(VisibilityIconWrapper, { onClick: () => setShowPassword(!showPassword) }, showPassword ? (React.createElement(VisibilityOutlinedIcon, null)) : (React.createElement(VisibilityOffOutlinedIcon, null))))),
        touched && errorMessage && React.createElement(ErrorMessage, null, errorMessage)));
};
export default ValidatedInput;
